import React from 'react';
import propTypes from 'prop-types';
import { LoaderCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { isMobileWebView, postMobileNavigate } from 'helpers/mobileWebView';

const badgeClassName =
  'flex items-center gap-3 bg-black/80 p-4 rounded-xl w-40 shrink-0 cursor-pointer hover:bg-black/60 transition-colors';

export default function ApptBadge({ icon, label, count, loading }) {
  const content = (
    <>
      {icon}
      <div className='flex w-full flex-col items-end gap-0 leading-none'>
        <span className='text-lg font-semibold text-white leading-none'>
          {loading ? <LoaderCircle className='animate-spin' /> : count}
        </span>
        <span className='text-sm text-grey-lighter leading-none'>{label}</span>
      </div>
    </>
  );

  if (isMobileWebView()) {
    return (
      <button
        type='button'
        className={`${badgeClassName} border-0 text-left`}
        onClick={() => postMobileNavigate('/myAppointments')}
      >
        {content}
      </button>
    );
  }

  return (
    <Link className={badgeClassName} to='/myAppointments'>
      {content}
    </Link>
  );
}

ApptBadge.propTypes = {
  icon: propTypes.node,
  label: propTypes.string.isRequired,
  count: propTypes.number.isRequired,
  loading: propTypes.bool.isRequired
};
